<template>
  <div class="container view my-5">
    <div class="container invoice" id="print">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div>
                <div>
                  <div class="row invo-header">
                    <div class="col-sm-6">
                      <div class="d-flex align-items-center">
                        <div class="flex-grow-1 m-l-20">
                          <h4 class="d-flex-headin">TELANUSA MARITIME TRAINING</h4>
                          <p>
                            service@telanusamaritimetraining.com<br /><span
                              class="digits"
                            >
                              +6281355585758</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="text-md-end text-xs-center">
                        <h3>
                          Invoice #<span class="digits counter">{{
                            detailOrder?.order_code
                          }}</span>
                        </h3>
                        <p>Issued: {{ formattedDate(detailOrder?.created_at) }}</p>
                        <div>
                          Order:
                          <span class="badge text-bg-info">{{
                            detailOrder?.order_status
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="row invo-profile">
                  <div class="col-xl-4">
                    <div class="invo-profile-left">
                      <div class="d-flex">
                        <div class="flex-grow-1 ms-3">
                          <h4 class="d-flex-heading">
                            {{ detailOrder?.member_information?.fullname }}
                          </h4>
                          <p>
                            {{ detailOrder?.member_information?.email }}<br /><span
                              class="digits"
                              >+{{ detailOrder?.member_information?.phone }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-8">
                    <div class="invo-profile-right">
                      <div id="project" class="text-xl-end"><h6>Training</h6></div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="invoice-table" id="table">
                    <table class="table table-bordered table-striped">
                      <tbody>
                        <tr>
                          <td class="Training"><h6 class="p-2 mb-0">Training</h6></td>
                          <td class="Jadwal"><h6 class="p-2 mb-0">Jadwal</h6></td>
                          <td class="Harga"><h6 class="p-2 mb-0">Harga</h6></td>
                          <td class="subtotal"><h6 class="p-2 mb-0">Sub-total</h6></td>
                        </tr>
                        <tr
                          v-for="items in detailOrder.order_detail"
                          v-bind:key="items.id"
                        >
                          <td>
                            <p class="itemtext digits">{{ items.product_name }}</p>
                          </td>
                          <td>
                            <p class="itemtext digits">
                              {{ formattedDate(items.batch_start_date) }} -
                              {{ formattedDate(items.batch_end_date) }} December 2024
                            </p>
                          </td>
                          <td>
                            <p class="itemtext digits">USD {{ items.product_price }}</p>
                          </td>
                          <td>
                            <p class="itemtext digits">USD {{ items.product_price }}</p>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="Rate"><h6 class="mb-0 p-2">Total</h6></td>
                          <td class="payment digits">
                            <p class="itemtext digits fw-bold">
                              USD
                              {{ detailOrder?.trx?.total_amount }}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row mt-3">
                    <div class="col-md-8">
                      <div>
                        <p class="legal">
                          <strong>Thank you for your business!</strong>Payment is expected
                          within 31 days; please process this invoice within that time.
                          There will be a 5% interest charge per month on late invoices.
                        </p>
                      </div>
                    </div>
                    <div class="col-md-4"><form class="text-end invo-pal"></form></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import axios, { all } from "axios";
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import Swal from "sweetalert2";

const isLoading = ref(false);
const orderCode = ref();
const route = useRoute();
const detailOrder = ref({});
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;

orderCode.value = route.params.orderCode;
const loadDetailOrder = async () => {
  axios({
    method: "get",
    url: apiBaseUrl + "order/detail?order_code=" + orderCode.value,
  })
    .then((response) => {
      detailOrder.value = response.data.data;
      console.log(detailOrder.value);
    })
    .catch((error) => {
      isLoading.value = false;
      Swal.fire({
        title: "Error",
        text: Array.isArray(error.response.data.message)
          ? error.response.data.message.join(", ")
          : error.response.data.message,
        icon: "warning",
      });
    });
};

loadDetailOrder();

const formattedDate = (date) => {
  const validDate = new Date(date);

  const year = validDate.getFullYear();
  const month = String(validDate.getMonth() + 1).padStart(2, "0");
  const day = String(validDate.getDate()).padStart(2, "0");

  return `${day}-${month}-${year}`;
};
</script>
